export type ConnectionNotice = 'hidden' | 'interrupted' | 'offline' | 'restored' | 'stopping';

/** Allow brief stream reconnects; report confirmed request failures immediately. */
export const createConnectionNotice = (onChange: (state: ConnectionNotice) => void) => {
  let state: ConnectionNotice = 'hidden';
  let pending: ReturnType<typeof setTimeout> | undefined;
  let recovery: ReturnType<typeof setTimeout> | undefined;
  const set = (next: ConnectionNotice) => {
    if (state !== next) { state = next; onChange(next); }
  };
  return {
    update(connected: boolean, online: boolean, stopping = false, requestFailed = false) {
      if (!online) {
        clearTimeout(pending); pending = undefined;
        clearTimeout(recovery);
        set('offline');
      } else if (stopping) {
        clearTimeout(pending); pending = undefined;
        clearTimeout(recovery);
        set('stopping');
      } else if (connected && !requestFailed) {
        clearTimeout(pending); pending = undefined;
        if (state === 'interrupted' || state === 'offline' || state === 'stopping') {
          set('restored');
          recovery = setTimeout(() => set('hidden'), 5000);
        }
      } else {
        clearTimeout(recovery);
        if (requestFailed || state === 'offline' || state === 'stopping') {
          clearTimeout(pending); pending = undefined;
          set('interrupted');
          return;
        }
        if (state === 'restored') set('hidden');
        if (state === 'hidden' && pending === undefined) {
          pending = setTimeout(() => { pending = undefined; set('interrupted'); }, 10000);
        }
      }
    },
    close() { clearTimeout(pending); clearTimeout(recovery); },
  };
};
